// COPYRIGHT © 2019 Esri
//
// All rights reserved under the copyright laws of the United States
// and applicable international laws, treaties, and conventions.
//
// This material is licensed for use under the Esri Master License
// Agreement (MLA), and is bound by the terms of that agreement.
// You may redistribute and use this code without modification,
// provided you adhere to the terms of the MLA and include this
// copyright notice.
//
// See use restrictions at http://www.esri.com/legal/pdfs/mla_e204_e300/english
//
// For additional information, contact:
// Environmental Systems Research Institute, Inc.
// Attn: Contracts and Legal Services Department
// 380 New York Street
// Redlands, California, USA 92373
// USA
//
// email: contracts@esri.com
//
// See http://js.arcgis.com/next/esri/copyright.txt for details.

define({lblItem:"elemento",title:"Iniciar sesión",info:"Inicie sesión para acceder al elemento en {server} {resource}",oAuthInfo:"Inicie sesión en {server}.",lblUser:"Nombre de usuario:",lblPwd:"Contraseña:",lblOk:"Aceptar",lblSigning:"Ingresando...",lblCancel:"Cancelar",errorMsg:"Usuario/contraseña no válido. Inténtalo de nuevo.",invalidUser:"El nombre de usuario o la contraseña que has introducido son incorrectos.",forbidden:"El nombre de usuario y la contraseña son válidos, pero no dispones de acceso a este recurso.",noAuthService:"No se pudo acceder al servicio de autenticación."});